// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var WarningSolid = function WarningSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warningsolid-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 1.25a1.56 1.56 0 0 1 1.348.773l8.438 14.375a1.56 1.56 0 0 1-1.348 2.352H1.563c-.559 0-1.078-.3-1.355-.785a1.57 1.57 0 0 1 .007-1.567L8.653 2.023A1.56 1.56 0 0 1 10 1.25m0 5a.935.935 0 0 0-.937.938v4.375c0 .519.418.937.938.937.519 0 .937-.418.937-.937V7.187a.935.935 0 0 0-.937-.937M11.25 15a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warningsolid-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
